import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/numerique";
export default function SecteurNumerique() { return <SectorLayout data={data} />; }
